import AppealsModule from './vuex/index';
import apiAppeals from './api/appeals';

let appeals = new AppealsModule(apiAppeals);

export default appeals;


// WEBPACK FOOTER //
// ./src/modules/appeals/index.js